<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/qzzp.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/qzzp_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>通讯</span><span style="color:#D7230C;">录</span></div>
							<div class="sm_pub">获取商务人士联系方式</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">通讯录</div>
				</div>
				<el-select v-model="value" placeholder="请选择" style="width: 150px;float: left;margin-left: 20px;">
					<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<div class="Bigcosousuo">
					<input v-model="keyword" type="text" placeholder="请输入内容">
					<div @click="selectChild1">
						搜索
					</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div style="width: 95%;margin: 0 auto;height: 1050px;">
					<div v-for="(item,index) in dataList" :key="index"
						style="width: 24%;height: 250px;margin-left: 0.8%;float: left;margin-top: 15px;border: 1px solid #ececec;box-shadow: #6e6e6e 0px 0px 10px;"
						class="NewArrialsb">
						<div style="height: 150px;">
							<img src="../../../imges/mpxgt.png" style="width: 100%;height: 100%;filter: blur(5px);" alt="">
						</div>
						<div style="height: 20px;text-align: center;line-height: 20px;font-weight: 700;font-size: 18px; overflow: hidden;
										white-space: nowrap;
										text-overflow: ellipsis;">
							{{item.company}}
						</div>
						<div style="height: 20px;text-align: center;line-height: 20px;font-weight: 500;font-size: 14px; overflow: hidden;
																white-space: nowrap;
																text-overflow: ellipsis;">
							{{item.position}} &nbsp; *{{item.title.slice(-1)}}
						</div>
						<div style="height: 20px;text-align: center;line-height: 20px;font-weight: 500;font-size: 14px; overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;">
							手机： ****{{`${item.phone}`.substring(4,7)}}****
						</div>
						 <!-- @click="DS_ck(item.id)" -->
						<div @click="das(item.id,item.title)"
							style="height: 30px;text-align: center;line-height: 30px;font-weight: 700;font-size: 14px;color: crimson;width: 40%;margin: 0 auto;border: 1px solid #D7230C;border-radius: 5px;margin-top: 5px;">
							<!-- 付费查看 -->
							<i class="el-icon-thumb"></i>
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="PageSize" layout="total, prev, pager, next"
						:total="Totals">
					</el-pagination>
				</div>
			</div>


		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
		<dashang ref="dashang"></dashang>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				value: '',
				dataLists: '',
				currentPage: 1, //当前页
				PageSize: 12, //当前每页数据
				Totals: 100, //总数据条数
				keyword: '', //搜索框查询关键字
				dataList: [],
			}
		},
		methods: {
			async selectChild1() {
				if (this.keyword == '') {
					alert('请输入内容')
				}
				let res = await http.post('api/Common/index', {
					model:'bscard',
					type:'content',
					mid:'5',
					rows_limit:'16',
					company: this.keyword,
					fid:this.value
				})
				this.dataList = res.data.data.list.data
				this.Totals = res.data.data.list.total
				this.currentPage = res.data.data.list.current_page
			},
			async das(id, sb) {
				let that = this
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					let res = await http.post('api/picture/login_yz', {
						tid: id,
						nologin_type: 'txl',
						uid: loginInfo.id
					})
			
					console.log(res)
					if (res.data.code == 500) {
						this.$refs.dashang.DS_ck(20, '通讯录查看', 'txl', id)
						// that.$refs.child.isShowZF = true //修改子组件data
					} else {
						this.$router.push({
							path:`/txldetail?id=${id}&title=${sb},`
						})
					}
				} else {
					this.$message.error('请先登录');
					this.$router.replace('/login')
				}
			},
			handleSizeChange(val) {},
			async handleCurrentChange(val) {
				let res = await http.post('api/Common/index', {
					model:'bscard',
					type:'content',
					mid:'5',
					rows_limit:'16',
					page: val,
					title: this.keyword
				})
				this.dataList = res.data.data.list.data
				this.Totals = res.data.data.count
				this.currentPage = res.data.data.list.current_page
			},
			async DS_ck(id){
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo == null) {
				  this.$message.error('请先登录');
				  this.$router.push({
				    path: '/login'
				  })
				  return false;
				}
				let res = await http.post('api/picture/login_yz',{
					tid: id,
					nologin_type:'txl',
					uid:loginInfo.id
				})
				if(res.data.code ==500){
					this.$refs.dashang.DS_ck(20.00,'查看通讯录','txl',id)
				}else{
					this.$router.push({
						path: '/txl/detail?id='+id
					})
				}
			}
		},
		async mounted() {
			let res = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res.data.data
			let res1 = await http.get('api/Common/index', {
				model: 'bscard',
				type: 'content',
				mid: '5',
				rows_limit: '16',
			})
			this.dataList = res1.data.data.list.data
			console.log(this.dataList)
			this.Totals = res1.data.data.list.total
			this.currentPage = res1.data.data.list.current_page
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//未知
			dashang: resolve => require(['@/components/dashang/dashangs'], resolve),
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		height: 1200px;
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}

	.Bigcosousuo {
		float: left;
		width: 300px;
		height: 36px;
		border: 1px solid #ececec;
		margin-left: 20px;
		background-color: #D7230C;
	}

	/deep/ .Bigcosousuo .el-input__inner {
		border-radius: 0px;
		border-right: none;
		height: 36px;
	}

	.Bigcosousuo>input {
		width: 80%;
		height: 34px;
		float: left;
		border: 0px;
		outline: none;
	}

	.Bigcosousuo>div {
		width: 18%;
		height: 36px;
		float: left;
		line-height: 36px;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
		text-align: center;
	}

	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1150px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}
</style>
